import * as Sentry from '@sentry/browser';

const dataset = document.getElementById('sentry-script')?.dataset;
if (!dataset || !dataset.dsn || !dataset.env) {
	console.error('Sentry not initialized - missing dataset');
} else {
	try {
		Sentry.init({
			dsn: dataset.dsn,
			integrations: [Sentry.browserTracingIntegration(), Sentry.httpContextIntegration()],
			tracesSampleRate: 0.0,
			replaysOnErrorSampleRate: 0.1,
			replaysSessionSampleRate: 0,
			environment: dataset.env,
			sendDefaultPii: true,
			ignoreErrors: [
				'Failed to fetch',
				'Unexpected token \'else\'',
				'null is not an object (evaluating',
				'undefined is not an object (evaluating \'a.N\')',
				'undefined is not an object (evaluating \'a.L\')',
				'Cannot redefine property: googletag',
				'Unexpected token \';\'. Expected \')\' to end a compound expression.',
				'Unexpected token \';\'',
				'Can\'t find variable: sznIVA',
				'Non-Error promise rejection captured',
				'Cannot read properties of undefined (reading \'touches\')', //Todo: remove when https://coweo.myjetbrains.com/youtrack/issue/JP-6426/aktualizace-JS-front-yarn-build will release
				'Cannot read properties of null (reading \'touches\')', //Todo: remove when https://coweo.myjetbrains.com/youtrack/issue/JP-6426/aktualizace-JS-front-yarn-build will release
				'missing ) after argument list',
			],
			allowUrls: [/https?:\/\/((www|dev|test)\.)?jenprace\.(cz|l|test)/, 'localhost'],
		});

		if (dataset.user) {
			Sentry.setUser(JSON.parse(dataset.user));
		}

	} catch (e) {
		console.error(e);
	}
}
